import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import { UserProvider } from './UserContext';
import { QueryProvider } from './QueryProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <BrowserRouter>
      <QueryProvider>
        <UserProvider>
          <ErrorBoundary>{children}</ErrorBoundary>
        </UserProvider>
      </QueryProvider>
    </BrowserRouter>
  );
};
